import React from 'react';
import PropTypes from 'prop-types';
import Formera from 'formera';
import isEmail from 'validator/lib/isEmail';
import isPostalCode from 'validator/lib/isPostalCode';
import formator from './formator';
import { possibleAgesOfPersonWithIdNumber, validateNorwegianIdNumber } from 'norwegian-national-id-validator';
import MyField from './MyField';
import MaskedInput from 'react-text-mask';
import { withRouter } from "react-router-dom";

import Checkbox from './Checkbox';


class FormContainer extends React.Component {
 state = { isBooked: false };
  onSubmit = (formState, { setErrors }) => {
    // alert(JSON.stringify(formState, null, 2));

    const errors = {};

    if (Object.keys(this.props.bookingData).length === 0) {
      errors.bookingError = (this.props.lang.pickAProductFirst);
      setErrors(errors);
      return;
    }

    if (formator.personalid(formState.values.personalId, 'DEFAULT')) {
      const pnr = formator.personalid(formState.values.personalId, 'DEFAULT');

      formState.values.personalId = pnr;
    }


    let allData;


    if (this.props.voucher !== undefined) {
      allData = Object.assign(
        {},
        { bookingData: this.props.bookingData },
        { bookingInfo: formState.values },
          { bIKey: this.props.bIKey },
        { voucher: this.props.voucher },
      );
    } else {
      allData = Object.assign(
        {},
        { bookingData: this.props.bookingData },
        { bookingInfo: formState.values },
          { bIKey: this.props.bIKey },
      );
    }


    return fetch(
      process.env.REACT_APP_NEWBOOKING,
      {
        method: 'post',
        headers: {
          accept: 'application/json',
          'Content-Type': 'application/json',
        },

        body: JSON.stringify(allData, null, 2),
      },
    ).then(this.handleResponse)
      .then(data => this.reactRouteRedirect(data))
      .catch(error => setErrors({ bookingError: error.error }));

    /*
      // do something awesome that makes the world a better place
      if (response.status === 200) {
        console.log('response', response);
        // return response;
        // window.location.href = `http://homestead.test/payment/${response.json()}`;
      } else {

      }
      // const err = new Error(response.statusText);
      // err.response = response;
    //  throw err;
    });


    /*

    .then(res => res.json())
      .catch(error => console.error('Error:', error))
      .then(response => this.redirectOnComplete(response));

    */
  }


  handleResponse(response) {
    return response.json()
      .then((json) => {
        if (response.status === 200) {
          // this.redirectOnComplete(json);
        }
        if (response.ok) {
          return json;
        }

        const error = Object.assign({}, json, {
          status: response.status,
          statusText: response.statusText,
        });
        return Promise.reject(error);
      });
  }

  redirectOnComplete = (url) => {
    console.log('redirect');
    console.log(url);
    this.setState({ isBooked: true });
    window.location.href = process.env.REACT_APP_REDIRECT + url;
  };

  reactRouteRedirect = (url) => {
    this.props.history.push(`/widget/booking/${url}`)
  };

  personalIdSweden = (input) => {
    // Check valid length & form
    if (!input) { return false; }

    if (input.indexOf('-') === -1) {
      if (input.length === 10) {
        input = `${input.slice(0, 6)}-${input.slice(6)}`;
      } else {
        input = `${input.slice(0, 8)}-${input.slice(8)}`;
      }
    }
    if (!input.match(/^(\d{2})(\d{2})(\d{2})-(\d{4})|(\d{4})(\d{2})(\d{2})-(\d{4})$/)) { return false; }

    // Clean input
    input = input.replace('-', '');
    if (input.length === 12) {
      input = input.substring(2);
    }

    // Declare variables
    let d = new Date(((RegExp.$1) ? RegExp.$1 : RegExp.$5), (((RegExp.$2) ? RegExp.$2 : RegExp.$6) - 1), ((RegExp.$3) ? RegExp.$3 : RegExp.$7)),
      sum = 0,
      numdigits = input.length,
      parity = numdigits % 2,
      i,
      digit;

    // Check valid date
    if (Object.prototype.toString.call(d) !== '[object Date]' || isNaN(d.getTime())) return false;

    // Check luhn algorithm
    for (i = 0; i < numdigits; i += 1) {
      digit = parseInt(input.charAt(i), 10);
      if (i % 2 === parity) { digit *= 2; }
      if (digit > 9) { digit -= 9; }
      sum += digit;
    }
    return (sum % 10) === 0;
  }


  doesFieldExist = (fieldName) => {
    const { inputFields } = this.props;

    const findField = inputFields.find(obj => obj.name === fieldName);

    return findField;
  };

  validator = (field, { values }) => {
    const errors = {};

    const { lang } = this.props;


    if (this.doesFieldExist('firstName')) {
      if (!values.firstName) {
        errors.firstName = lang.firstNameIsRequired;
      }
    }

    if (this.doesFieldExist('surName')) {
      if (!values.surName) {
        errors.surName = lang.surNameIsRequired;
      }
    }

    if (this.doesFieldExist('address')) {
      if (!values.address) {
        errors.address = lang.addressIsRequired;
      }
    }


    if (this.doesFieldExist('city')) {
      if (!values.city) {
        errors.city = lang.cityIsRequired;
      }
    }

    if (this.doesFieldExist('zip')) {
      if (values.zip) {
        if (!isPostalCode(values.zip, 'SE')) {
          errors.zip = lang.zipIsRequired;
        }
      } else {
        errors.zip = 'Zip is required';
      }
    }

    if (this.doesFieldExist('phone')) {
      if (values.phone) {
        if (!formator.cellphone(values.phone, 'INT_FORMAT')) {
          errors.phone = 'Fel format!';
        }
      } else {
        errors.phone = lang.phoneIsRequired;
      }
    }

    if (this.doesFieldExist('email')) {
      if (values.email) {
        if (!isEmail(values.email)) {
          errors.email = lang.emailHasToBeCorrect;
        }
      } else {
        errors.email = lang.emailIsRequired;
      }
    }

      if (this.doesFieldExist('email_confirmation')) {
          if (values.email_confirmation) {
              if (values.email !== values.email_confirmation) {
                  errors.email_confirmation = lang.emailHasToEqualEmail
              }
          }
      }



    if (this.doesFieldExist('personalId')) {
      if (values.personalId) {
        if (!this.personalIdSweden(values.personalId) &&
          !validateNorwegianIdNumber(values.personalId)) {
          errors.personalId = lang.personalIdIsRequired;
        }
      } else {
        errors.personalId = lang.personalIdIsRequired;
      }
    }


    if (!values.terms) {
      errors.terms = lang.termsIsRequired;
    }

    return errors;
  };

  render() {
    const initialValues = {
      /* firstName: 'Andreas',
      surName: 'Padde',
      address: 'bergslagsgatan 6',
      zip: '41104',
      city: 'gothenburg',
      phone: '031-982000',
      email: 'a@a.se', */
    };

    const styles = {
      fontFamily: 'sans-serif',
      textAlign: 'left',
    };

    const {
      bookingData, inputFields, hashId, lang,
    } = this.props;
    const { isBooked } = this.state;

    return (
      <div style={styles}>


        <Formera
          onSubmit={this.onSubmit}
          validate={this.validator}
          initialValues={initialValues}
          render={({
 isSubmitting, handleSubmit, errors, ...restFormeraProps
}) => (
  <div>
    <form className="form-horizontal" onSubmit={handleSubmit} disabled={isSubmitting} >

      {inputFields.map(({ name, label }) => (

        <MyField key={name} name={name} label={label} />

                ))}


        <Checkbox
        name="terms"
        lang={lang}
        label="Accept the terms"
        type="checkbox"
        hashId={hashId}
      />

      {errors && (
      <div style={{ color: 'red' }}>{errors.bookingError}</div>

                  )}

      {isBooked ? lang.moveToConfirmedBooking : (<button className="btn btn-primary" disabled={isSubmitting} >{lang.bookButton}</button>)}


    </form>

    {1 === 2 && (
    <pre>{JSON.stringify(restFormeraProps, null, 2)}</pre>
              )}


  </div>
          )}

        />
      </div>

    );
  }
}


export default withRouter(FormContainer);



// WEBPACK FOOTER //
// ./src/components/Summary/components/FormContainer.jsx